import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "partner-area pb-75" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = {
  href: "https://wa.me/447429916178",
  target: "_blank",
  class: "partner-bg mb-4"
}
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-xxl-2 col-sm-6 col-md-4",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": (index + 1) * 100
          }, [
            _createElementVNode("a", _hoisted_5, [
              _createElementVNode("img", {
                src: partner.image,
                alt: partner.alt
              }, null, 8, _hoisted_6)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}